/* BIONIKA 2026-09-09 — Logisztikai díj automatika (HU webshop).
 * Ha a kosár értéke (a díj nélkül, kedvezmények után) a küszöb alatt van, a
 * „Logisztikai díj" terméket (handle: kezelesi-koltseg) 1 db-ban a kosárba
 * tesszük; a küszöb felett vagy üres kosárnál kivesszük.
 * Konfig: window.BNK_HANDLING_FEE = { variantId, threshold (Ft×100), handle }
 * — a layout/theme.liquid állítja elő az all_products['kezelesi-koltseg']-ből.
 * Kiváltók: oldalbetöltés, pageshow (checkoutból vissza), a téma cartUpdate
 * eseménye, továbbá minden /cart/add|change|update|clear hívás (fetch + XHR).
 */
(function () {
  'use strict';
  var cfg = window.BNK_HANDLING_FEE;
  if (!cfg || !cfg.variantId || !cfg.threshold) return;
  var VID = Number(cfg.variantId);
  var THRESHOLD = Number(cfg.threshold);
  var SRC = 'bnk-handling-fee';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var own = 0;        // saját, folyamatban lévő kosár-hívások száma (hurok-védelem)
  var running = null; // futó sync Promise
  var queued = false;
  var timer = null;
  var inflight = new Set(); // idegen (nem saját) kosár-módosító kérések, még válasz nélkül
  var DBG = false; try { DBG = localStorage.getItem('bnkFeeDebug') === '1'; } catch (_) {}
  function dbg() { if (DBG) console.log.apply(console, ['[BNK fee dbg]'].concat([].slice.call(arguments))); }
  var retry = 0;            // nem-JSON válasz (pl. 429 botvédelmi oldal) utáni újrapróbálás számlálója
  var RETRY_MS = [1500, 4000, 10000];

  // A Shopify botvédelme terhelés alatt a kosár-végpontokra HTML „Just a moment…" oldalt ad
  // 429-cel; ilyenkor nem dobunk el mindent, hanem visszavárva újrapróbálunk.
  // FIGYELEM: a tartalomtípus-fejléc NEM megbízható (a /cart/*.js válaszai 200-zal is
  // jöhetnek nem-json típussal), ezért a törzset próbáljuk értelmezni.
  function asJson(r) {
    return r.text().then(function (t) {
      try { return JSON.parse(t); } catch (_) {
        var e = new Error('nem JSON válasz: ' + r.status); e.retryable = true; throw e;
      }
    });
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }

  function jsonFetch(path, body) {
    own++;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(asJson)
      .finally(function () { own--; });
  }

  function decide(cart) {
    var fee = [], base = cart.total_price;
    (cart.items || []).forEach(function (it) {
      if (it.variant_id === VID) { fee.push(it); base -= it.final_line_price; }
    });
    var others = (cart.items || []).length - fee.length;
    var want = others > 0 && base < THRESHOLD;
    if (want && fee.length === 0) return jsonFetch('cart/add.js', { items: [{ id: VID, quantity: 1 }] });
    if (want && (fee.length > 1 || fee[0].quantity !== 1)) {
      var up = {};
      fee.forEach(function (it, i) { up[it.key] = i === 0 ? 1 : 0; });
      return jsonFetch('cart/update.js', { updates: up });
    }
    if (!want && fee.length) {
      var rm = {};
      fee.forEach(function (it) { rm[it.key] = 0; });
      return jsonFetch('cart/update.js', { updates: rm });
    }
    return null;
  }

  // A sablon-szekciók (kosároldal tételek/lábléc) VALÓDI azonosítója a template-ben
  // kapott id (pl. template--…__cart-footer), nem a fájlnév: fájlnévvel kérve a szekció
  // blokkok nélkül (összesítő, pénztár gomb nélkül) renderelődik, és a végösszeg nem frissül.
  function sectionIdOf(el) {
    var w = el && el.closest('.shopify-section');
    return w && w.id ? w.id.replace(/^shopify-section-/, '') : null;
  }
  function rerender() {
    var names = [];
    var cartItemsEl = document.querySelector('cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var itemsId = sectionIdOf(cartItemsEl), footerId = sectionIdOf(footerEl);
    if (document.querySelector('cart-drawer')) names.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) names.push('cart-icon-bubble');
    if (itemsId) names.push(itemsId);
    if (footerId) names.push(footerId);
    if (!names.length) return Promise.resolve();
    var base = window.location.pathname || root;
    return fetch(base + (base.indexOf('?') < 0 ? '?' : '&') + 'sections=' + names.join(','), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sec) {
        var parse = function (html) { return new DOMParser().parseFromString(html || '', 'text/html'); };
        if (sec['cart-drawer']) {
          var cd = document.querySelector('cart-drawer');
          var src = parse(sec['cart-drawer']).querySelector('cart-drawer');
          if (cd && src) {
            cd.className = src.className;
            cd.innerHTML = src.innerHTML;
            var ov = cd.querySelector('#CartDrawer-Overlay');
            if (ov && typeof cd.close === 'function') ov.addEventListener('click', cd.close.bind(cd));
          }
        }
        if (sec['cart-icon-bubble']) {
          var b = parse(sec['cart-icon-bubble']).querySelector('.shopify-section');
          if (b) document.getElementById('cart-icon-bubble').innerHTML = b.innerHTML;
        }
        if (itemsId && sec[itemsId] && cartItemsEl) {
          var sdoc = parse(sec[itemsId]);
          var sci = sdoc.querySelector('cart-items');
          if (sci) {
            cartItemsEl.innerHTML = sci.innerHTML;
            cartItemsEl.className = sci.className;
            var wrap = cartItemsEl.closest('.shopify-section');
            var swrap = sdoc.querySelector('.shopify-section') || sdoc.body;
            if (wrap && wrap.firstElementChild && swrap.firstElementChild) {
              wrap.firstElementChild.className = swrap.firstElementChild.className;
            }
          }
        }
        if (footerId && sec[footerId] && footerEl) {
          var sf = parse(sec[footerId]).getElementById('main-cart-footer');
          if (sf) {
            footerEl.className = sf.className;
            var a = footerEl.querySelector('.js-contents'), c = sf.querySelector('.js-contents');
            if (a && c) a.innerHTML = c.innerHTML;
          }
        }
      })
      .catch(function () {});
  }

  // sync(cart?): ha a módosítás válasza már a teljes kosár (change/update/clear), abból
  // döntünk AZONNAL, külön /cart.js lekérés nélkül; különben friss kosarat kérünk.
  function sync(known) {
    dbg('sync', known ? 'known' : 'fresh', 'running=' + !!running);
    if (running) { queued = true; return running; }
    var src = known && known.items && known.token ? Promise.resolve(known)
      : fetch(root + 'cart.js', { cache: 'no-store' }).then(asJson);
    running = src
      .then(function (cart) {
        var act = decide(cart);
        dbg('decide', cart.total_price, (cart.items || []).map(function (i) { return i.variant_id + 'x' + i.quantity; }).join(','), act ? 'ACT' : 'nincs teendő');
        if (!act) return;
        return act.then(function (res) {
          if (res && res.status && res.status >= 400) { console.warn('[BNK fee]', res.description || res.message); return; }
          return rerender().then(function () {
            if (hasPubSub()) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: SRC, cartData: res });
            }
            // saját módosítás után egy FRISS ellenőrző kör (a közben érkezett válaszok
            // elavult kosárképe ne okozzon dupla díjat)
            queued = true;
          });
        });
      })
      .then(function () { retry = 0; })
      .catch(function (e) {
        console.warn('[BNK fee]', e && e.message ? e.message : e);
        if (e && e.retryable && retry < RETRY_MS.length) {
          setTimeout(schedule, RETRY_MS[retry++]);
        }
      })
      .finally(function () {
        running = null;
        if (queued) { queued = false; schedule(); }
      });
    return running;
  }

  // Minden kosárváltozás után AZONNAL újraszámolunk (nincs csendes idő); a torlódást a
  // running/queued sorbaállítás kezeli: futás közben érkező változás után még egyszer lefut.
  function schedule(known) {
    dbg('schedule', known && known.items ? 'known' : 'fresh');
    clearTimeout(timer);
    timer = setTimeout(function () { timer = null; sync(known); }, 0);
  }

  // Pénztár előtt: megvárjuk a függő kosár-hívásokat, lefuttatjuk a szinkront, és csak
  // utána engedjük tovább — különben a gyors kattintás megelőzi a díj be-/kivételét.
  function settle(round) {
    round = round || 0;
    clearTimeout(timer);
    // a Dawn a mennyiség-változást 300 ms-mal késleltetve küldi (ON_CHANGE_DEBOUNCE_TIMER),
    // ezért először kivárjuk, hogy a függő kérés egyáltalán elinduljon.
    var wait = round === 0 ? 400 : 0;
    return new Promise(function (r) { setTimeout(r, wait); })
      .then(function () { return Promise.allSettled(Array.from(inflight)); })
      .then(function () { return running || sync(); })
      .then(function () {
        if ((inflight.size || queued || timer) && round < 3) { return settle(round + 1); }
      });
  }
  function onCheckoutClick(e) {
    var btn = e.target && e.target.closest && e.target.closest('button[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!btn || btn.dataset.bnkFeeReady === '1' || btn.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('loading');
    var timeout = new Promise(function (r) { setTimeout(r, 6000); });
    Promise.race([settle(), timeout]).then(function () {
      btn.dataset.bnkFeeReady = '1';
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
      if (btn.tagName === 'A') { window.location.href = btn.href; return; }
      var form = btn.form || btn.closest('form');
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit(btn);
      else if (form) { form.submit(); }
      else window.location.href = root + 'checkout';
      setTimeout(function () { delete btn.dataset.bnkFeeReady; }, 1500);
    });
  }
  document.addEventListener('click', onCheckoutClick, true);

  // --- kiváltók -------------------------------------------------------------
  // window.fetch burkolása ÚJRAÍRÁS-ÁLLÓ módon: más szkript (pl. a CMS session-replay.js) később
  // `window.fetch = saját(nativeFetch)` alakban lecseréli — sima felülírással a mi burkolónk
  // kiesne. Accessor-tulajdonsággal a beállítás csak a belső hívott függvényt cseréli, a mi
  // burkolónk marad a láncban.
  var _fetch = window.fetch, _nativeFetch = _fetch, _depth = 0;
  var bnkFetch = function (input, init) {
    // BIONIKA 2026-10-02: ha egy későbbi szkript (Shopify shop_events_listener) a getteren át
    // a MI burkolónkat csomagolja be, majd azt a setteren át _fetch-be teszi, a lánc önmagába
    // hurkol (bnkFetch → wrapper → bnkFetch …) → „Maximum call stack size exceeded" minden
    // fetch-nél, a PJAX-navigáció elakad. Újrabelépéskor a natív fetch-et hívjuk.
    if (_depth) return _nativeFetch.apply(this, arguments);
    var p;
    _depth++;
    try { p = _fetch.apply(this, arguments); } finally { _depth--; }
    var url = typeof input === 'string' ? input : (input && input.url);
    dbg('fetch', url, 'own=' + own, isCartMutation(url) ? 'MUTATION' : '');
    if (own === 0 && isCartMutation(url)) {
      inflight.add(p);
      p.then(function (res) {
        // a válasz törzse (ha teljes kosár) egyből a döntés alapja
        if (res && res.ok) {
          return res.clone().text().then(function (t) {
            var cart = null; try { cart = JSON.parse(t); } catch (_) {}
            schedule(cart || undefined);
          }, function () { schedule(); });
        }
        schedule();
      }, function () {}).finally(function () { inflight.delete(p); });
    }
    return p;
  };
  try {
    Object.defineProperty(window, 'fetch', {
      configurable: true, enumerable: true,
      get: function () { return bnkFetch; },
      set: function (fn) { if (typeof fn === 'function' && fn !== bnkFetch) _fetch = fn; }
    });
  } catch (_) { window.fetch = bnkFetch; }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (isCartMutation(url)) {
      var done, p = new Promise(function (r) { done = r; });
      inflight.add(p);
      this.addEventListener('loadend', function () { inflight.delete(p); done(); if (own === 0) schedule(); });
    }
    return _open.apply(this, arguments);
  };
  // FIGYELEM: a Dawn `const PUB_SUB_EVENTS` top-level konstans, NEM window-tulajdonság —
  // `window.PUB_SUB_EVENTS` mindig undefined, ezért typeof-fal kell vizsgálni.
  function hasPubSub() {
    return typeof subscribe === 'function' && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }
  function subscribeTheme() {
    if (hasPubSub()) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        dbg('cartUpdate esemény', ev && ev.source);
        if (!ev || ev.source !== SRC) schedule();
      });
      return true;
    }
    return false;
  }
  if (!subscribeTheme()) document.addEventListener('DOMContentLoaded', subscribeTheme);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
  // Visszatérés a lapra (másik fülön/eszközön módosított kosár): újraszámolás.
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') schedule(); });
  window.BnkHandlingFee = { sync: sync, settle: settle, debug: function () {
    return { running: !!running, queued: queued, timer: !!timer, inflight: inflight.size, own: own, retry: retry };
  } };
})();
